module.exports = __webpack_public_path__ + "static/media/jh.5982c5a1.jpg";